// import { ChatOpenAI } from "langchain/chat_models/openai";
import { Document } from "langchain/document";
import { MemoryVectorStore } from "langchain/vectorstores/memory";
// class CustomTextSplitter extends TextSplitter {
import { OpenAIEmbeddings } from "langchain/embeddings/openai";
import { VectorStoreRetrieverMemory } from "langchain/memory";
import { OpenAI } from "langchain/llms/openai";

// const apiKey = process.env.OPENAI_KEY;
const OPENAI_API_KEY =  process.env.REACT_APP_OPENAI_KEY
var embeddings = new OpenAIEmbeddings({ openAIApiKey: OPENAI_API_KEY}) 
const vectorStore = new MemoryVectorStore(
  // new OpenAIEmbeddings({ openAIApiKey: apiKey })
  embeddings
);

const model2 = new OpenAI({
  temperature: 0.5,
  openAIApiKey: OPENAI_API_KEY 
  // openAIApiKey: apiKey // In Node.js defaults to process.env.OPENAI_API_KEY
});

const memory = new VectorStoreRetrieverMemory({
  // 1 is how many documents to return, you might want to return more, eg. 4
  vectorStoreRetriever: vectorStore.asRetriever(4),
  memoryKey: "history"
});

async function splitText(text) {
  // Split the text into chunks of 100 characters
  const chunkSize = 100;
  const chunks = [];
  for (let i = 0; i < text.length; i += chunkSize) {
    chunks.push(text.slice(i, i + chunkSize));
  }
  return chunks;
}

export async function vectorStorer(pdfText) {
  // Create a custom TextSplitter

  // Split the large chunk of text into smaller chunks
  // const largeText = "This is a large chunk of text.";
  const chunks = await splitText(pdfText);
  // const chunks2 = await splitText2(pdfText);

  // Create documents from the chunks and add them to the MemoryVectorStore
  const documents = await chunks.map(
    (chunk) => new Document({ pageContent: chunk })
  );
  console.log("i am documents", documents);

  await vectorStore.addDocuments(documents);

  // if (documents.length > 0) {
  //   await memory.saveContext(documents);
  // }

  // await memory.saveContext(
  //   { input: "My favorite food is pizza" },
  //   { output: "thats good to know" }
  //   // chunks2
  // );

  // console.log("memory, vectorStoreMem", memory, vectorStoreMem);
  return await vectorStore;
}

export async function vectorStorer2(pdfText) {
  const chunks = await splitText(pdfText);

  const documents = chunks.map((chunk) => new Document({ pageContent: chunk }));

  await vectorStore.addDocuments(documents);

  // Check if the documents were added successfully
  // const addedDocuments = await vectorStore.getDocuments();
  // console.log("Added documents:", addedDocuments);

  // Continue with other operations using the vectorStore

  return vectorStore;
}

export async function querySimilarity(queryText, k = 5) {
  // Embed the query text
  const queryVector = await embeddings.embedQuery(queryText);

  // Perform the similarity search using the query vector
  // const searchResults = await vectorStore.similaritySearchVectorWithScore(
  //   queryVector,
  //   k
  // );
  const searchResults = await vectorStore.similaritySearchVectorWithScore(
    queryVector,
    k
  );

  // console.log("pre process", searchResults);
  // Process and return the search results
  // const formattedResults = searchResults.map(([document, similarity]) => ({
  //   documentContent: document.pageContent,
  //   similarityScore: similarity
  // }));

  const formattedResults2 = searchResults.map(
    ([document, similarity]) => document.pageContent
  );

  // console.log("formattedResults2", formattedResults2);

  return formattedResults2;
}

export async function generateResponse(queryText, searchResults) {
  // Construct the prompt using the original query and search results

  console.log("query, text", queryText, searchResults);
  const prompt = `User Query: ${queryText}\n\n. Use this query to generate a response using the following text that is properly formatted in markdown. Exactly follow the query's instructions:\n${searchResults}`;

  const response = await model2.call(
    // "are you a snoogle or boogle. define snoogle"
    prompt
  );

  console.log(response);
  // Extract and return the generated response text
  // return response.choices[0].text;
  return response;
}

export async function generateResponseHighlight(queryText, reset) {
  // Construct the prompt using the original query and search results

  console.log("query, text", queryText, reset);
  const prompt = `User Query: ${queryText}\n\n. `;

  // if(reset)
  // {
  //   memory.clear()
  // }

  const response = await model2.call(
    // "are you a snoogle or boogle. define snoogle"
    prompt
  );

  // console.log("generateResponseHighlight", response);
  // Extract and return the generated response text
  // return response.choices[0].text;
  return response;
}

// export function formatSearchResults(searchResults) {
//   // return searchResults
//   //   .map((result, index) => `${index + 1}. Document: ${result.documentContent}\n   Similarity Score: ${result.similarityScore}`)
//   //   .join("\n");
//   console.log("i am formatSearchRes", searchResults);
//   return searchResults
//     .map((result, index) => `${index + 1}. Document: ${result.documentContent}`)
//     .join("\n");
// }
